/**
 * ajax
 */

 // 开发环境
const isDevelopment = process.env.NODE_ENV === 'dev' || process.env.NODE_ENV === 'development'

 // 参数拼接
const serialize = (obj = {}) => {
  const params = []
  for (const key in obj) {
    params.push(encodeURIComponent(key) + '=' + encodeURIComponent(obj[key]))
  }
  return params.join('&').replace(/%20/g, '+')
}

export default ({
  type = 'POST',
  url = '',
  data = {},
  success = () => {},
  error = () => {}
} = {}) => {
  const params = serialize(data)
  const xhr = new XMLHttpRequest()
  xhr.open(type, url)
  xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded')
  xhr.withCredentials = !isDevelopment
  xhr.send(params || null)
  xhr.onreadystatechange = () => {
    if (xhr.readyState === 4) {
      try {
        if (xhr.status >= 200 && xhr.status < 300) {
          success(JSON.parse(xhr.response))
        } else {
          error(xhr.statusText)
        }
      } catch (e) {
        console.error('Collect Error:', e)
      }
    }
  }
}


// WEBPACK FOOTER //
// ./node_modules/@common/collect/src/lib/ajax.js